import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { StagesValidators } from "common/form/stages-validators";

@Directive({
	selector: "[stagesEmail]",
	providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }],
})

/*
    this validator is used for a more specific email validation check. The angular provided validator
    proves an email address in the format xxxx@xxx. as an proper address.
*/
export class EmailValidatorDirective implements Validator {
	@Input()
	validatorPatterns!: stages.context.ValidatorPatterns;

	validate(control: AbstractControl): ValidationErrors | null {
		return StagesValidators.stagesEmail(this.validatorPatterns)(control);
	}
}
